// Tiny DOM helpers for the imperative HUD.

export function el<K extends keyof HTMLElementTagNameMap>(tag: K, cls?: string, text?: string): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (text !== undefined) e.textContent = text;
  return e;
}

export function div(cls?: string, text?: string): HTMLDivElement {
  return el("div", cls, text);
}

export function span(cls?: string, text?: string): HTMLSpanElement {
  return el("span", cls, text);
}

/** Set `textContent` only when it changed. Returns true when the DOM was touched. */
export function setText(node: Node, text: string): boolean {
  if (node.textContent === text) return false;
  node.textContent = text;
  return true;
}

/** Toggle a class only when its state differs from `on`. */
export function setClass(node: Element, cls: string, on: boolean): void {
  if (node.classList.contains(cls) !== on) node.classList.toggle(cls, on);
}

export function setHidden(node: HTMLElement, hidden: boolean): void {
  if (node.hidden !== hidden) node.hidden = hidden;
}

/** Restart a one-shot Web Animation on `node` (cancels the previous run). */
export function play(node: Element, keyframes: Keyframe[], options: KeyframeAnimationOptions): Animation {
  for (const a of node.getAnimations()) a.cancel();
  return node.animate(keyframes, options);
}
